import React from "react";
import { Auth, Hub } from "aws-amplify";
import { Button } from "react-bootstrap";

export default function IconLabelTabs() {
  const handleSignOutButtonClick = async () => {
    try {
      await Auth.signOut();
      Hub.dispatch("UI Auth", {
        // channel must be 'UI Auth'
        event: "AuthStateChange", // event must be 'AuthStateChange'
        message: "signedout", // message must be 'signedout'
      });
    } catch (error) {
      console.log("error signing out: ", error);
    }
  };

  return (
    <div align="center">
      <h1><a href="/" style={{ color: 'white' }}>AXA Go Disaster Recovery Management App</a></h1>
      {/* <Container fluid="md"> */}
      <Button
        className="signout"
        variant="outline-warning"
        onClick={handleSignOutButtonClick}
      >
        Sign Out
      </Button>{" "}
    </div>
  );
}
